.wrapper {
  margin-bottom: var(--dds-spacing-small-16);
}

.manualSearch {
  display: flex;
  flex-flow: row;
  margin-top: var(--dds-spacing-large-48);

  button {
    margin-top: var(--dds-spacing-medium-24);
    margin-left: var(--dds-spacing-small-8);
    margin-bottom: var(--dds-spacing-small-8);
  }
}
